import styled from "styled-components"

export const Container = styled.div`
    display: ${props => props.display};
    flex-direction: column;
    justify-content: center;
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;
`

export const Title = styled.h1`
    font-weight: 200;
    margin-bottom: 20px;
`